import axios from "axios";
import { Observable } from "rxjs";
import config from "../../config/config";
import Cookie from "cookies-js";
const https = require('https');

var API_URL = config.API_URL
// if(process.env.NODE_ENV == "production"){
//   API_URL = "http://127.0.0.1:8081/"
// }

const agent = new https.Agent({  
    rejectUnauthorized: false
});

export const Manage_admin_service = {
    add_admin_service,
    search_admin,
    updateAdmin,
    deleteAdmin,
    getAdGroup,
    getAdUsers
};

function add_admin_service(data) {
    return Observable.create(observer => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.post(config.API_URL + "admin/register/?authorization="+json_cookie.token+'&lang=th', data)
            .then(response => {
                if (response.data.status === 200) {
                    observer.next(response.data.data);
                } else {
                    observer.error(response.data);
                }
                observer.complete();
            })
            .catch(error => {
                observer.error(error);
            });
    });
}

function search_admin(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject)=>{
        axios.get(config.API_URL+'manage_admin/searchAdmin/?authorization='+json_cookie.token, {params : data})
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function updateAdmin(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject)=>{
        axios.post(config.API_URL+'manage_admin/updateAdmin/?authorization='+json_cookie.token, data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function deleteAdmin(data) {
    return Observable.create(observer => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.post(config.API_URL + "manage_admin/deleteAdmin/?authorization=" + json_cookie.token, { admin_id: data }).then(response => {
            if (response.data.status === 200) {
                observer.next(response.data.data);
            } else {
                observer.error(response.data);
            }
            observer.complete();
        }).catch(err => {
            observer.error(err)
        })
    })
}

function getAdGroup(){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject)=>{
        axios.get(config.API_URL+'ad/groups/?authorization='+json_cookie.token)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getAdUsers(formdata){
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + 'ad/users', formdata, { httpsAgent: agent })
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}